import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

const useStyles = makeStyles((theme) => ({
  headerStyling: {
    backgroundColor: "#1c355e",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: { height: 44 },
    [theme.breakpoints.down('sm')]: { height: 36 },
  },
  typoStyling: {
    color: "#fff",
    [theme.breakpoints.up("sm")]: { fontSize: 20, paddingTop: 7 },
    [theme.breakpoints.down('sm')]: { fontSize: 18, paddingTop: 5 },
  },
}));

const SelectSignature = ({
  reportSignatures,
  user,
  selectedSignatureId,
  setSelectedSignatureId,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleChange = (event) => {
    setSelectedSignatureId(parseInt(event.target.value));
  };

  return (
    <>
      <Grid container className={classes.headerStyling}>
        <Grid item xs={2}></Grid>
        <Grid item xs={6}>
          <Typography className={classes.typoStyling}>
            {t("documents.signature")}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className={classes.typoStyling}>
            {t("documents.initials")}
          </Typography>
        </Grid>
      </Grid>

      <FormControl
        component="fieldset"
        style={{ width: "100%", textAlign: "center" }}
      >
        <RadioGroup value={selectedSignatureId} onChange={handleChange}>
          {reportSignatures.map((signature) => {
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                key={signature.reportSignatureId}
              >
                <Grid item xs={2}>
                  <FormControlLabel
                    key={signature.reportSignatureId}
                    value={signature.reportSignatureId.toString()}
                    control={<Radio color="default" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <div style={{ fontFamily: signature.font }}>
                    {user.firstName + " " + user.lastName}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div style={{ fontFamily: signature.font }}>
                    {user?.clientName}
                  </div>
                </Grid>
              </Grid>
            );
          })}
        </RadioGroup>
      </FormControl>
    </>
  );
};

SelectSignature.propTypes = {
  reportSignatures: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  selectedSignatureId: PropTypes.string.isRequired,
  setSelectedSignatureId: PropTypes.func.isRequired,
};

export default SelectSignature;
